module.exports = __webpack_public_path__ + "img/delivery-ubereats.06961609.svg";